import { useState } from 'react';
import { Plus, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { TemplateList } from '@/components/templates/TemplateList';
import { TemplateFormDialog } from '@/components/templates/TemplateFormDialog';
import { useSyncZenviaTemplates } from '@/hooks/useTemplates';
import type { Template } from '@/types/api.types';

export function TemplatesPage() {
  const [formOpen, setFormOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<Template | null>(null);
  const syncMutation = useSyncZenviaTemplates();

  function handleEdit(template: Template) {
    setEditTarget(template);
    setFormOpen(true);
  }

  function handleCreate() {
    setEditTarget(null);
    setFormOpen(true);
  }

  function handleFormOpenChange(open: boolean) {
    setFormOpen(open);
    if (!open) setEditTarget(null);
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Templates</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Gerencie seus templates de mensagem WhatsApp
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={() => syncMutation.mutate()}
            disabled={syncMutation.isPending}
          >
            <RefreshCw className={`h-4 w-4 ${syncMutation.isPending ? 'animate-spin' : ''}`} />
            Sincronizar da Zenvia
          </Button>
          <Button onClick={handleCreate}>
            <Plus className="h-4 w-4" />
            Novo template
          </Button>
        </div>
      </div>

      <Card>
        <CardContent className="pt-6">
          <TemplateList onEdit={handleEdit} />
        </CardContent>
      </Card>

      <TemplateFormDialog
        open={formOpen}
        onOpenChange={handleFormOpenChange}
        template={editTarget}
      />
    </div>
  );
}
